import React, { ChangeEvent } from "react";

type InputFieldProps = {
  placeholder?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  pw?: boolean;
}

type InputFieldBoxProps = {
  label: string;
  placeholder?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  pw?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({ placeholder, value, onChange, pw=false }) => (
  <div className="contact-box__ct">
    <input type="text" className={`input ${pw ? "input--pw" : ""}`} placeholder={placeholder} value={value} onChange={onChange} />
  </div>
);

export const InputFieldBox: React.FC<InputFieldBoxProps> = ({ label, placeholder, value, onChange, required = false, pw=false }) => (
  <div className="contact-box__item">
    <label className="contact-box__ttl">
      <span>{label}</span>
      { required && <small>必須</small> }
    </label>
    <InputField placeholder={placeholder} value={value} onChange={onChange} pw={pw} />
  </div>
);
